// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NEjEb","icon":"styles_icon__2SGc2"};